import Blues from './optimized/color-blues.jpg';
import Greens from './optimized/color-greens.jpg';
import Metallics from './optimized/color-metallics.jpg';
import Neutrals from './optimized/color-neutrals.jpg';
import Oranges from './optimized/color-oranges.jpg';
import Pinks from './optimized/color-pinks.jpg';
import Purples from './optimized/color-purples.jpg';
import Reds from './optimized/color-reds.jpg';
import Yellows from './optimized/color-yellows.jpg';
import BlackWhiteTie from './optimized/style-blacktie.jpg';
import Boho from './optimized/style-boho.jpg';
import Classic from './optimized/style-classic.jpg';
import Glamorous from './optimized/style-glamorous.jpg';
import Industrial from './optimized/style-industrial.jpg';
import Modern from './optimized/style-modern.jpg';
import Natural from './optimized/style-natural.jpg';
import Outdoor from './optimized/style-outdoor.jpg';
import Romantic from './optimized/style-romantic.jpg';
import Rustic from './optimized/style-rustic.jpg';
import Traditional from './optimized/style-traditional.jpg';
import Vintage from './optimized/style-vintage.jpg';

export interface FacetQuizlet {
  type: 'color' | 'style';
  name: string;
  key: string;
  tag?: {
    text: string;
    symbol: string;
    alt: string;
  };
  gradient: string;
  glitter?: boolean;
  image: string;
  // These are computed with a npm package call gip
  // npm install -g gip
  // gip <file>
  //   gives a background color and gradient
  placeholder: {
    background: string;
    gradient: string;
  };
}
const STYLE_GRADIENT = 'linear-gradient(180deg, #FFABA9 0%, #FBC0AD 100%)';

export const STYLE_QUIZLETS: FacetQuizlet[] = [
  {
    type: 'style',
    name: 'Glamorous',
    key: 'style-glamorous',
    gradient: STYLE_GRADIENT,
    image: Glamorous,
    placeholder: {
      background: '#a77aaa',
      gradient: 'linear-gradient(to bottom, #b48eac 0%, #442b61 100%)',
    },
  },
  {
    type: 'style',
    name: 'Black/White Tie',
    key: 'style-black-tie-white-tie',
    gradient: STYLE_GRADIENT,
    image: BlackWhiteTie,
    placeholder: {
      background: '#d7d5d3',
      gradient: 'linear-gradient(to bottom, #e3e8ec 0%, #34312a 100%)',
    },
  },
  {
    type: 'style',
    name: 'Boho',
    key: 'style-boho',
    gradient: STYLE_GRADIENT,
    image: Boho,
    placeholder: {
      background: '#322822',
      gradient: 'linear-gradient(135deg, #4d372d 0%, #1d1b17 100%)',
    },
  },
  {
    type: 'style',
    name: 'Classic',
    key: 'style-classic',
    gradient: STYLE_GRADIENT,
    image: Classic,
    placeholder: {
      background: '#ebc3c4',
      gradient: 'linear-gradient(135deg, #f6cccd 0%, #dfbebf 100%)',
    },
  },

  {
    type: 'style',
    name: 'Industrial',
    key: 'style-urban-industrial',
    gradient: STYLE_GRADIENT,
    image: Industrial,
    placeholder: {
      background: '#59443b',
      gradient: 'linear-gradient(135deg, #453530 0%, #957058 100%)',
    },
  },
  {
    type: 'style',
    name: 'Modern',
    key: 'style-modern',
    gradient: STYLE_GRADIENT,
    image: Modern,
    placeholder: {
      background: '#b2aca2',
      gradient: 'linear-gradient(45deg, #64594c 0%, #dadddd 100%)',
    },
  },
  {
    type: 'style',
    name: 'Natural',
    key: 'style-natural',
    gradient: STYLE_GRADIENT,
    image: Natural,
    placeholder: {
      background: '#c0b6a4',
      gradient: 'linear-gradient(45deg, #b4a085 0%, #c5c2b4 100%)',
    },
  },
  {
    type: 'style',
    name: 'Outdoor',
    key: 'style-outdoor',
    gradient: STYLE_GRADIENT,
    image: Outdoor,
    placeholder: {
      background: '#8b6544',
      gradient: 'linear-gradient(45deg, #704c2e 0%, #dfd1c2 100%)',
    },
  },
  {
    type: 'style',
    name: 'Romantic',
    key: 'style-romantic',
    gradient: STYLE_GRADIENT,
    image: Romantic,
    placeholder: {
      background: '#332a23',
      gradient: 'linear-gradient(to bottom, #362924 0%, #2f2925 100%)',
    },
  },
  {
    type: 'style',
    name: 'Rustic',
    key: 'style-rustic',
    gradient: STYLE_GRADIENT,
    image: Rustic,
    placeholder: {
      background: '#4f3423',
      gradient: 'linear-gradient(to right, #ccbca9 0%, #432b1c 100%)',
    },
  },
  {
    type: 'style',
    name: 'Traditional',
    key: 'style-traditional',
    gradient: STYLE_GRADIENT,
    image: Traditional,
    placeholder: {
      background: '#c6b49d',
      gradient: 'linear-gradient(135deg, #d0c1ac 0%, #c0ab92 100%)',
    },
  },
  {
    type: 'style',
    name: 'Vintage',
    key: 'style-vintage',
    gradient: STYLE_GRADIENT,
    image: Vintage,
    placeholder: {
      background: '#d3d2d7',
      gradient: 'linear-gradient(to bottom, #d3d2d7 0%, #b6b4b2 100%)',
    },
  },
];

export const COLOR_QUIZLETS: FacetQuizlet[] = [
  {
    type: 'color',
    name: 'Purple',
    key: 'color-purples',
    gradient: 'linear-gradient(180deg, #CAC9FF 0%, #F1CFFA 100%)',
    tag: {
      text: 'Purples',
      symbol: '💜',
      alt: 'purple heart',
    },
    placeholder: {
      background: '#cdbdc6',
      gradient: 'linear-gradient(to right, #d9c7d4 0%, #bea8b2 100%)',
    },

    image: Purples,
  },
  {
    type: 'color',
    name: 'Blue',
    key: 'color-blues',
    gradient: 'linear-gradient(180deg, #A9C6FF 0%, #DEDCF4 100%)',
    tag: {
      text: 'Blues',
      symbol: '💎',
      alt: 'blue diamond',
    },
    placeholder: {
      background: '#aab0b7',
      gradient: 'linear-gradient(45deg, #515d74 0%, #cccccd 100%)',
    },
    image: Blues,
  },
  {
    type: 'color',
    name: 'Red',
    key: 'color-reds',
    gradient: 'linear-gradient(180deg, #DE3131 0%, #FEA183 100%)',
    tag: {
      text: 'Reds',
      symbol: '🌹',
      alt: 'red rose',
    },
    placeholder: {
      background: '#524a4c',
      gradient: 'linear-gradient(135deg, #b2abae 0%, #4a484b 100%)',
    },
    image: Reds,
  },
  {
    type: 'color',
    name: 'Orange',
    key: 'color-oranges',
    gradient: 'linear-gradient(180deg, #FFAF95 0%, #FFDDA9 100%)',
    tag: {
      text: 'Oranges',
      symbol: '🍊',
      alt: 'orange fruit',
    },

    placeholder: {
      background: '#a56b4d',
      gradient: 'linear-gradient(45deg, #b26843 0%, #413729 100%)',
    },
    image: Oranges,
  },
  {
    type: 'color',
    name: 'Green',
    key: 'color-greens',
    gradient: 'linear-gradient(180deg, #A2E0C2 0%, #CAF1D4 100%)',
    tag: {
      text: 'Greens',
      symbol: '🌵',
      alt: 'green cactus',
    },
    placeholder: {
      background: '#c4b9b4',
      gradient: 'linear-gradient(135deg, #d2c7c3 0%, #4e6861 100%)',
    },

    image: Greens,
  },
  {
    type: 'color',
    name: 'Pink',
    key: 'color-pinks',
    gradient: 'linear-gradient(180deg, #FFA7A7 0%, #FFE3CF 100%)',
    tag: {
      text: 'Pinks',
      symbol: '🌸',
      alt: 'pink flower',
    },
    placeholder: {
      background: '#c89c8d',
      gradient: 'linear-gradient(to bottom, #cb9e8f 0%, #c59588 100%)',
    },

    image: Pinks,
  },

  {
    type: 'color',
    name: 'Yellow',
    key: 'color-yellows',
    gradient: 'linear-gradient(180deg, #FFE495 0%, #FFF1AA 100%)',
    tag: {
      text: 'Yellows',
      symbol: '🌞',
      alt: 'sun',
    },

    placeholder: {
      background: '#ddd7b3',
      gradient: 'linear-gradient(135deg, #d0c59f 0%, #e5e5c9 100%)',
    },

    image: Yellows,
  },
  {
    type: 'color',
    name: 'Metallic',
    key: 'color-metallics',
    gradient: 'linear-gradient(180deg, #FFBFBF 0%, #FBE9C7 100%)',
    glitter: true,
    tag: {
      text: 'Metallics',
      symbol: '✨',
      alt: 'sparkles',
    },
    placeholder: {
      background: '#d2bba0',
      gradient: 'linear-gradient(135deg, #e7d2b2 0%, #b49b89 100%)',
    },
    image: Metallics,
  },
  {
    type: 'color',
    name: 'Neutral',
    key: 'color-neutrals',
    gradient: 'linear-gradient(180deg, #CCD1DC 0%, #F9F7FF 100%)',
    tag: {
      text: 'Neutrals',
      symbol: '🐚',
      alt: 'white shell',
    },
    placeholder: {
      background: '#b6a093',
      gradient: 'linear-gradient(45deg, #bba9a0 0%, #b29e8f 100%)',
    },
    image: Neutrals,
  },
];
